import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ClassService, ConfigService } from './../../../../../_services';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigsDeadlineModalComponent } from '../configs-modals/deadline-modal/configs-deadline-modal.component';
import { Config } from '../../../../../_models/config';



@Component({
    selector: 'app-configs-deadline-invoice',
    templateUrl: './configs-deadline-invoice.component.html',
    styles: ['[class^="la-"], [class*=" la-"] { padding:5px; }',
        'a { text-decoration: none; }'
    ]
})
export class ConfigsDeadlineInvoiceComponent implements OnInit {
    @ViewChild('modalComponent') modalComponent: ConfigsDeadlineModalComponent;
    public configs: any[];
    public config_id: number;
    public model = new Config(null, null, null, null, null, null, null);
    public currentUser: any = JSON.parse(localStorage.getItem('currentUser'));

    tableMessages = {
        emptyMessage: 'No existen parámetros',
        totalMessage: ''
    };
    constructor(private _configService: ConfigService,
        private _modalService: NgbModal) { }

    ngOnInit() {
        this.getAllConfigs();
    }
    getIdConfig(id) {
        this.config_id = id;
    }

    getAllConfigs() {
        this._configService.getAll().subscribe(data => {
            this.configs = data.configs;
        }, err => {
            console.error(err);
        }, () => {

        });
    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/configs/configs-deadlineinvoice/configs-deadline-invoice.component.ts